define('jackpots',['util'], function (util) {
	var id = 0,
		gameCallbacks = [],
		defaultCallbacks = {
			create: null,
			remove: null,
			update: null,
			error: null
		},
		object = {
			jackpots: [],
			jackpotWinners: [],
			jackpotsWon: [],
			init: function (createCallback, removeCallback, updateCallback, errorCallback, gameNo) {
				var callbacks;

				gameCallbacks[gameNo] = defaultCallbacks;
				callbacks = gameCallbacks[gameNo];

				if (createCallback) {
					callbacks.create = createCallback;
				}
				if (removeCallback) {
					callbacks.remove = removeCallback;
				}
				if (updateCallback) {
					callbacks.update = updateCallback;
				}
				if (errorCallback) {
					callbacks.error = errorCallback;
				}
			},
			registerJackpots: function (url, gameNo) {
				var urls;

				// Don't register jackpots if dom is not ready
				if (!gameCallbacks[gameNo]) {
					return;
				}
				urls = url.map(util.formatURL);
				if (!this.jackpots[gameNo] || this.jackpots[gameNo].length === 0) {
					this.jackpots[gameNo] = [];
				}

				// Add new jackpots
				urls.forEach(function (jackpotUrl) {
					var exists = object.jackpots[gameNo].some(function (jackpot) {
						return jackpot.url === jackpotUrl;
					});

					if (!exists) {
						object.addJackpot(jackpotUrl, gameNo);
					}
				});

				// Remove deleted jackpots
				this.jackpots[gameNo].forEach(function (jackpot, i) {
					var exists = urls.some(function (jUrl) {
						return jackpot.url === jUrl;
					});

					if (!exists) {
						object.jackpots[gameNo].splice(i, 1);
						object.removeJackpot(jackpot, gameNo);
					}
				});
			},
			addJackpot: function (url, gameNo) {
				var jackpot = {
					gameNo: gameNo,
					url: url,
					id: id++,
					data: {},
					evtSource: null
				};

				this.jackpots[gameNo].push(jackpot);
				listenForEvents(jackpot);

				gameCallbacks[gameNo].create(jackpot, gameNo);
			},
			removeJackpot: function (jackpot, gameNo) {
				jackpot.evtSource.close();
				gameCallbacks[gameNo].remove(jackpot, gameNo);
			}
		};

	function listenForEvents(jackpot) {
		jackpot.evtSource = new EventSource(jackpot.url);
		jackpot.evtSource.addEventListener('jackpotUpdate', jackpotEvent, false);
		jackpot.evtSource.addEventListener('jackpotWin', jackpotEvent, false);

		jackpot.evtSource.onerror = function (e) {
			if (e.target.readyState === EventSource.CLOSED) {
				jackpot.evtSource.close();
				setTimeout(function () {
					listenForEvents(jackpot);
					gameCallbacks[0].error('translate_err8', 3000); // Same callback for both games
				}, 10000);
			}
		};
	}

	function jackpotEvent(e) {
		var data = JSON.parse(e.data),
			source = e.srcElement || e.target,
			jackpots = [],
			date,
			formatedDate,
			wonJackpot,
			repeatingJackpot = false;

		object.jackpots.forEach(function (jackpot) {
			var activeJackpot = jackpot.find(function (j) {
				return j.url === source.url;
			});

			if (activeJackpot) {
				jackpots.push(activeJackpot);
			}
		});

		if (e.type === 'jackpotUpdate') {
			jackpots.forEach(function (jackpot) {
				gameCallbacks[jackpot.gameNo].update(jackpot, data);
				jackpot.data = data;
			});
		}

		if (e.type === 'jackpotWin') {
			date = new Date();
			formatedDate = [
				util.doubleDigit(date.getMonth() + 1),
				util.doubleDigit(date.getDate())
			].join('-') + ' ' + [
				util.doubleDigit(date.getHours()),
				util.doubleDigit(date.getMinutes())
			].join(':');

			wonJackpot = {
				name: data.displayName,
				amount: data.type === 'ranged' ? data.currentAmount : data.fixedDropAmount,
				winnerId: data.winnerSlipId,
				date: formatedDate,
				jackpotInstanceId: data.jackpotInstanceId
			};

			repeatingJackpot = object.jackpotWinners.some(function (olderJackpotWinners) {
				return wonJackpot.jackpotInstanceId === olderJackpotWinners.jackpotInstanceId;
			});

			if (!repeatingJackpot) {
				object.jackpotWinners.push(wonJackpot);
				object.jackpotsWon.push(wonJackpot);
			}
		}
	}

	return object;
});

